import { useIsItemModifierSetAvailable } from 'src/modules/checkout/composables/sales-availability/items/IsItemModifierSetAvailable'
import { computed, toValue } from 'vue'

// Options is a hash containing fields that can be used to validate item modifier set availability.
const DEFAULT_OPTIONS = Object.freeze({
  salesChannel: null,
  orderItem: null
})

// itemModifierSets and options are optional, assuming the caller may intend to use computeAvailableItemModifierSets directly
export function useAvailableItemModifierSets (itemModifierSets = [], options = DEFAULT_OPTIONS) {
  const { isItemModifierSetAvailable } = useIsItemModifierSetAvailable()

  function computeAvailableItemModifierSets (itemModifierSets, { salesChannel, orderItem } = DEFAULT_OPTIONS) {
    return _(toValue(itemModifierSets))
      .filter(itemModifierSet => isItemModifierSetAvailable(itemModifierSet, { salesChannel, orderItem }).isAvailable)
      .sortBy(itemModifierSet => itemModifierSet.modifierSet.displayOrder)
      .value()
  }

  // We wrap itemModifierSets with computed to ensure reactivity
  // useAvailableItemModifierSets may be called with a null model, which wouldn't be reactive
  // e.g. props?.item?.itemModifierSets?.data before item is set
  // This would prevent availableItemModifierSets from reacting to changes in itemModifierSets
  // If itemModifierSets is set or already reactive, this is a safe no-op
  // This ensures useAvailableItemModifierSets is resilient without complicated usage requirements
  const availableItemModifierSets = computed(() => computeAvailableItemModifierSets(computed(() => itemModifierSets), options))

  return {
    computeAvailableItemModifierSets,
    availableItemModifierSets
  }
}
